module.exports = __webpack_public_path__ + "img/plus.d9c03cf8.svg";